(ns dashboard.demo-event-organizer
  (:require
   [malli.core :as mc]
   [malli.transform :as mt]
   [malli.generator :as mg]
   [dashboard.utils :refer [index-by]]
   ["date-fns" :refer
    [getDaysInMonth setDate format isSaturday isSunday addMonths subMonths
     isSameDay isToday isBefore eachDayOfInterval setYear setMonth endOfMonth
     startOfWeek endOfWeek startOfMonth getMonth parseISO]]))

(def events
  [{:id "1"
    :start "2022-10-07T09:00:00+09:00"
    :end "2022-10-13T09:00:00+09:00"}])

(def boutiques
  [{:boutiqueId "201"
    :nameJp "伊勢丹新宿本店"}
   {:boutiqueId "202"
    :nameJp "三越日本橋本店"}
   {:boutiqueId "204"
    :nameJp "横浜髙島屋"}
   {:boutiqueId "205"
    :nameJp "新宿伊勢丹1階"}
   {:boutiqueId "206"
    :nameJp "髙島屋玉川店"}
   {:boutiqueId "214"
    :nameJp "仙台藤崎"}
   {:boutiqueId "215"
    :nameJp "銀座並木通りブティック"}
   {:BoutiqueId "218"
    :nameJp "そごう横浜店"}
   {:boutiqueId "220"
    :nameJp "あべの"}
   {:boutiqueId "221"
    :nameJp "高島屋大阪店"}
   {:boutiqueId "222"
    :nameJp "阪急うめだ本店"}
   {:boutiqueId "223"
    :nameJp "松坂屋名古屋店"}
   {:boutiqueId "224"
    :nameJp "高島屋京都店"}
   {:boutiqueId "225"
    :nameJp "福屋"}
   {:boutiqueId "226"
    :nameJp "岩田屋"}
   {:boutiqueId "251"
    :nameJp "神戸大丸"}
   {:boutiqueId "253"
    :nameJp "名古屋三越"}
   {:boutiqueId "254"
    :nameJp "福岡大丸"}
   {:boutiqueId "255"
    :nameJp "心斎橋ブティック"}
   {:boutiqueId "256"
    :nameJp "大丸京都店"}
   {:boutiqueId "258"
    :nameJp "心斎橋大丸"}
   {:boutiqueId "259"
    :nameJp "名古屋"}
   {:boutiqueId "264"
    :nameJp "心斎橋ブティック"}
   {:boutiqueId "265"
    :nameJp "髙島屋新宿店"}
   {:boutiqueId "267"
    :nameJp "JR名古屋髙島屋"}
   {:boutiqueId "311"
    :nameJp "六本木ヒルズ店"}])

(def runners
  [{:id "1"
    :nameJp "五十嵐剛徳"}
   {:id "2"
    :nameJp "野秋玲子"}
   {:id "3"
    :nameJp "山本泉"}
   {:id "4"
    :nameJp "星和佳子"}
   {:id "5"
    :nameJp "石倉　順"}
   {:id "6"
    :nameJp "小松恵美子"}
   {:id "7"
    :nameJp "小口裕之"}
   {:id "8"
    :nameJp "宮野敦巳"}
   {:id "9"
    :nameJp "奥村奈穂美"}
   {:id "10"
    :nameJp "増野美希"}
   {:id "11"
    :nameJp "伊藤麗奈"}
   {:id "12"
    :nameJp "成冨良美"}
   {:id "13"
    :nameJp "永田典子"}
   {:id "14"
    :nameJp "松村秀生"}
   {:id "15"
    :nameJp "田中久美子"}
   {:id "16"
    :nameJp "原田　奨"}])

(def rooms
  [{:id "1"
    :name "Amethyst"
    :nameJp "Amethyst"
    :color "violet"}
   {:id "2"
    :name "Diamond"
    :nameJp "Diamond"
    :color "beige"}
   {:id "3"
    :name "Emerald"
    :nameJp "Emerald"
    :color "green"}
   {:id "4"
    :name "Ruby"
    :nameJp "Ruby"
    :color "red"}
   {:id "5"
    :name "Sapphire"
    :nameJp "Sapphire"
    :color "blue"}])

(def guests
  [{:id "inter"
    :firstName "Inter"
    :lastName ""
    :firstNameJp "Inter"
    :lastNameJp "Inter"
    :code "Inter"}
   {:id "1"
    :firstName "Hiroyuki"
    :lastName "Mori"
    :firstNameJp "裕之"
    :lastNameJp "森"
    :code "001"}
   {:id "2"
    :firstName "Shiko"
    :lastName "Matsuda"
    :firstNameJp "士光"
    :lastNameJp "松田"
    :code "002"}
   {:id "3"
    :firstName "Ayaho"
    :lastName "Miyamoto"
    :firstNameJp "綾保"
    :lastNameJp "宮本"
    :code "003"}
   {:id "4"
    :firstName "Noriko"
    :lastName "Nagata"
    :firstNameJp "典子"
    :lastNameJp "永田"
    :code "004"}
   {:id "5"
    :firstName "Yasuhiko"
    :lastName "Hamada"
    :firstNameJp "康彦"
    :lastNameJp "濱田"
    :code "005"}
   {:id "6"
    :firstName "Kazuyuki"
    :lastName "Ishikawa"
    :firstNameJp "和幸"
    :lastNameJp "石川"
    :code "006"}
   {:id "7"
    :firstName "John"
    :lastName "London"
    :firstNameJp "ジョン"
    :lastNameJp "ロンドン"
    :code "007"}
   {:id "8"
    :firstName "Beatrice"
    :lastName "de Navare"
    :firstNameJp "Beatrice"
    :lastNameJp "de Navare"
    :code "008"}
   {:id "9"
    :firstName "Shoji"
    :lastName "Nakamura"
    :firstNameJp "所持"
    :lastNameJp "中村"
    :code "009"}])

(def bookings
  [{:id "1"
    :bookingCode "1"
    :guestId "1"
    :eventId "1"
    :start "2022-10-07T10:30:00+09:00"
    :end   "2022-10-07T11:30:00+09:00"
    :checkIn "2022-10-07T10:32:03+09:00"
    :enter nil
    :exit nil
    :checkOut nil
    :clean nil
    :roomId "1"
    :salesId "3"
    :boutiqueId "201"
    :runnerIds ["1" "2"]}
   {:id "2"
    :bookingCode "2"
    :guestId "2"
    :eventId "1"
    :start "2022-10-07T10:30:00+09:00"
    :end   "2022-10-07T11:30:00+09:00"
    :checkIn "2022-10-07T10:35:14+09:00"
    :enter "2022-10-07T10:38:16+09:00"
    :exit "2022-10-07T11:39:23+09:00"
    :checkOut "2022-10-07T11:42:03+09:00"
    :clean nil
    :roomId "2"
    :salesId "3"
    :boutiqueId "202"
    :runnerIds ["3" "4"]}
   {:id "3"
    :bookingCode "3"
    :guestId "3"
    :eventId "1"
    :start "2022-10-07T10:30:00+09:00"
    :end   "2022-10-07T11:30:00+09:00"
    :checkIn "2022-10-07T10:31:14+09:00"
    :enter "2022-10-07T10:38:16+09:00"
    :exit "2022-10-07T11:39:23+09:00"
    :checkOut "2022-10-07T11:33:03+09:00"
    :clean nil
    :roomId "3"
    :salesId "3"
    :boutiqueId "204"
    :runnerIds ["3" "4"]}
   {:id "4"
    :bookingCode "4"
    :guestId "4"
    :eventId "1"
    :start "2022-10-07T10:30:00+09:00"
    :end   "2022-10-07T11:30:00+09:00"
    :checkIn "2022-10-07T10:31:14+09:00"
    :enter "2022-10-07T10:38:16+09:00"
    :exit "2022-10-07T11:39:23+09:00"
    :checkOut "2022-10-07T11:33:03+09:00"
    :clean nil
    :roomId "4"
    :salesId "3"
    :boutiqueId "222"
    :runnerIds ["5" "6"]}
   {:id "5"
    :bookingCode "5"
    :guestId "5"
    :eventId "1"
    :start "2022-10-07T10:30:00+09:00"
    :end   "2022-10-07T11:30:00+09:00"
    :checkIn "2022-10-07T10:30:00+09:00"
    :enter nil
    :exit nil
    :checkOut nil
    :clean nil
    :roomId "5"
    :salesId "3"
    :boutiqueId "215"
    :runnerIds ["7" "8"]}
   {:id "6"
    :bookingCode "6"
    :guestId "6"
    :eventId "1"
    :start "2022-10-07T12:30:00+09:00"
    :end   "2022-10-07T14:30:00+09:00"
    :checkIn "2022-10-07T12:38:03+09:00"
    :enter "2022-10-07T12:40:16+09:00"
    :exit nil
    :checkOut nil
    :clean nil
    :roomId "1"
    :salesId "3"
    :boutiqueId "201"
    :runnerIds ["1" "2"]}
   {:id "7"
    :bookingCode "7"
    :guestId "7"
    :eventId "1"
    :start "2022-10-07T12:30:00+09:00"
    :end   "2022-10-07T14:30:00+09:00"
    :checkIn "2022-10-07T12:38:03+09:00"
    :checkOut nil
    :clean nil
    :roomId "2"
    :salesId "3"
    :boutiqueId "223"
    :runnerIds ["3" "4"]}
   {:id "8"
    :bookingCode "8"
    :guestId "8"
    :eventId "1"
    :start "2022-10-07T12:30:00+09:00"
    :end   "2022-10-07T14:30:00+09:00"
    :checkIn nil
    :checkOut nil
    :clean nil
    :roomId "2"
    :salesId "3"
    :boutiqueId "223"
    :runnerIds ["5" "6"]}
   {:id "9"
    :bookingCode "9"
    :guestId "9"
    :eventId "1"
    :start "2022-10-07T12:30:00+09:00"
    :end   "2022-10-07T14:30:00+09:00"
    :checkIn nil
    :enter nil
    :exit nil
    :checkOut nil
    :clean nil
    :roomId "3"
    :salesId "3"
    :boutiqueId "225"
    :runnerIds ["7" "8"]}])

(def raw-bookings
  [{:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　18:30-20:30（VIPルーム)",
    :BTQ担当者名カナ "イトウマサヒロ",
    :BTQ名 "伊勢丹新宿本店",
    :人数 1,
    :予約コード 1,
    :POS名 "",
    :POS担当者名 "",
    :セイ "アサヒ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 201,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "その他（ご来場方法を備考欄にご記入ください）"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　12:30-14:30（VIPルーム)",
    :BTQ担当者名カナ "イトウマサヒロ",
    :BTQ名 "伊勢丹新宿本店",
    :人数 2,
    :予約コード 1,
    :POS名 "",
    :POS担当者名 "",
    :セイ "サトウ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 201,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　18:30-20:30（VIPルーム)",
    :BTQ担当者名カナ "サクライ　ジュンコ",
    :BTQ名 "三越日本橋本店",
    :人数 3,
    :予約コード 2,
    :POS名 "",
    :POS担当者名 "",
    :セイ "ハヤシ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 202,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　16:30-18:30（セミプライベート）",
    :BTQ担当者名カナ "キバヤシ　タカヒロ",
    :BTQ名 "髙島屋玉川店",
    :人数 2,
    :予約コード 4,
    :POS名 "",
    :POS担当者名 "",
    :セイ "オウ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 206,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "自家用車でご来場（＊お車情報を備考にご記入ください）"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　14:30-16:30（セミプライベート）",
    :BTQ担当者名カナ "ハガ　エミ",
    :BTQ名 "仙台藤崎",
    :人数 3,
    :予約コード 7,
    :POS名 "",
    :POS担当者名 "",
    :セイ "ハナヤマ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 214,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　10:30-12:30（VIPルーム)",
    :BTQ担当者名カナ "コダマ　トウコ",
    :BTQ名 "銀座並木通りブティック",
    :人数 2,
    :予約コード 8,
    :POS名 "",
    :POS担当者名 "",
    :セイ "ヨネハラ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 215,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　14:30-16:30（VIPルーム)",
    :BTQ担当者名カナ "マツウチ　サナエ",
    :BTQ名 "銀座並木通りブティック",
    :人数 2,
    :予約コード 8,
    :POS名 "",
    :POS担当者名 "",
    :セイ "ホシノ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 215,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "自家用車でご来場（＊お車情報を備考にご記入ください）"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　16:30-18:30（セミプライベート）",
    :BTQ担当者名カナ "サカイ　クニオ",
    :BTQ名 "そごう横浜店",
    :人数 2,
    :予約コード 9,
    :POS名 "",
    :POS担当者名 "",
    :セイ "イトウ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 218,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　14:30-16:30（VIPルーム)",
    :BTQ担当者名カナ "ウエムカイ　ナオミ",
    :BTQ名 "高島屋大阪店",
    :人数 2,
    :予約コード 11,
    :POS名 "",
    :POS担当者名 "",
    :セイ "アサノ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 221,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　16:30-18:30（VIPルーム)",
    :BTQ担当者名カナ "ウチダ　カズマ",
    :BTQ名 "阪急うめだ本店",
    :人数 2,
    :予約コード 12,
    :POS名 "",
    :POS担当者名 "",
    :セイ "オガワ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 222,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　10:30-12:30（セミプライベート）",
    :BTQ担当者名カナ "ナカガワミツコ",
    :BTQ名 "阪急うめだ本店",
    :人数 2,
    :予約コード 12,
    :POS名 "",
    :POS担当者名 "",
    :セイ "イノウエ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 222,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "その他（ご来場方法を備考欄にご記入ください）"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　12:30-14:30（VIPルーム)",
    :BTQ担当者名カナ "ナンブ　マサアキ",
    :BTQ名 "阪急うめだ本店",
    :人数 2,
    :予約コード 12,
    :POS名 "",
    :POS担当者名 "",
    :セイ "トミヤス",
    :ハイヤー備考2日目 "",
    :boutiqueCode 222,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　10:30-12:30（セミプライベート）",
    :BTQ担当者名カナ "タカハシカズミ",
    :BTQ名 "松坂屋名古屋店",
    :人数 2,
    :予約コード 13,
    :POS名 "",
    :POS担当者名 "",
    :セイ "オオムラ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 223,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　10:30-12:30（VIPルーム)",
    :BTQ担当者名カナ "イシノマスミ",
    :BTQ名 "高島屋京都店",
    :人数 2,
    :予約コード 14,
    :POS名 "",
    :POS担当者名 "",
    :セイ "ハン",
    :ハイヤー備考2日目 "",
    :boutiqueCode 224,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　16:30-18:30（VIPルーム)",
    :BTQ担当者名カナ "イワモト　チカコ",
    :BTQ名 "心斎橋ブティック",
    :人数 2,
    :予約コード 19,
    :POS名 "",
    :POS担当者名 "",
    :セイ "モリヤ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 255,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　14:30-16:30（VIPルーム)",
    :BTQ担当者名カナ "イワモト　チカコ",
    :BTQ名 "心斎橋ブティック",
    :人数 2,
    :予約コード 19,
    :POS名 "",
    :POS担当者名 "",
    :セイ "ウラタ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 255,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　12:30-14:30（VIPルーム)",
    :BTQ担当者名カナ "ヤマネ　エリカ",
    :BTQ名 "大丸京都店",
    :人数 1,
    :予約コード 20,
    :POS名 "",
    :POS担当者名 "",
    :セイ "サノ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 256,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　16:30-18:30（VIPルーム)",
    :BTQ担当者名カナ "タキザワ　シゲユキ",
    :BTQ名 "銀座ブティック",
    :人数 2,
    :予約コード 23,
    :POS名 "",
    :POS担当者名 "",
    :セイ "マツイ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 264,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　16:30-18:30（VIPルーム)",
    :BTQ担当者名カナ "スギモト　シャルルイッセイ",
    :BTQ名 "銀座ブティック",
    :人数 2,
    :予約コード 23,
    :POS名 "",
    :POS担当者名 "",
    :セイ "ツチカワ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 264,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　10:30-12:30（VIPルーム)",
    :BTQ担当者名カナ "マツモトロミー",
    :BTQ名 "銀座ブティック",
    :人数 3,
    :予約コード 23,
    :POS名 "",
    :POS担当者名 "",
    :セイ "ヤスダ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 264,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　16:30-18:30（セミプライベート）",
    :BTQ担当者名カナ "イワタ　ギンミ",
    :BTQ名 "銀座ブティック",
    :人数 2,
    :予約コード 23,
    :POS名 "",
    :POS担当者名 "",
    :セイ "ハマサキ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 264,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　12:30-14:30（VIPルーム)",
    :BTQ担当者名カナ "イワタ　ギンミ",
    :BTQ名 "銀座ブティック",
    :人数 1,
    :予約コード 23,
    :POS名 "",
    :POS担当者名 "",
    :セイ "イナダ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 264,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　10:30-12:30（セミプライベート）",
    :BTQ担当者名カナ "タキザワ　シゲユキ",
    :BTQ名 "銀座ブティック",
    :人数 2,
    :予約コード 23,
    :POS名 "",
    :POS担当者名 "",
    :セイ "ヒラノ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 264,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　16:30-18:30（セミプライベート）",
    :BTQ担当者名カナ "アオヤマ　カオル",
    :BTQ名 "銀座ブティック",
    :人数 2,
    :予約コード 23,
    :POS名 "",
    :POS担当者名 "",
    :セイ "ナカムラ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 264,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考
    "日本橋高島屋でのVIP顧客。毎月2,000万以上をコンスタントにお買い上げとのことでグラフ、ハリーウィンストンでのVIPイベント実績あり。",
    :顧客ID "",
    :予約商品名 "10月08日(土)　10:30-12:30（VIPルーム)",
    :BTQ担当者名カナ "アカハマ　タツヤ",
    :BTQ名 "髙島屋新宿店",
    :人数 4,
    :予約コード 24,
    :POS名 "",
    :POS担当者名 "",
    :セイ "ニシオ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 265,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　14:30-16:30（セミプライベート）",
    :BTQ担当者名カナ "タカナシ　ミナ",
    :BTQ名 "髙島屋新宿店",
    :人数 1,
    :予約コード 24,
    :POS名 "",
    :POS担当者名 "",
    :セイ "イナガキ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 265,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　16:30-18:30（セミプライベート）",
    :BTQ担当者名カナ "タナカクミコ",
    :BTQ名 "六本木ヒルズ店",
    :人数 2,
    :予約コード 26,
    :POS名 "",
    :POS担当者名 "",
    :セイ "ノナカ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 311,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}
   {:お客様情報備考 "",
    :顧客ID "",
    :予約商品名 "10月08日(土)　14:30-16:30（VIPルーム)",
    :BTQ担当者名カナ "カセ　ユミ",
    :BTQ名 "六本木ヒルズ店",
    :人数 2,
    :予約コード 26,
    :POS名 "",
    :POS担当者名 "",
    :セイ "ハトリ",
    :ハイヤー備考2日目 "",
    :boutiqueCode 311,
    :ハイヤー備考1日目 "",
    :管理番号 "",
    :お連れ様カナ "",
    :メイ "",
    :ハイヤー利用 "ハイヤー利用有"}])

(def demo-db
  {:logo "img/cartier_logo.svg"
   :logo-reversed "img/cartier_logo_reversed.svg"
   :company-name "Cartier"
   :organization {:id "1cd0febe-81eb-4959-8f75-ae24a16263af"
                  :name "Cartier"
                  :url "https://cartier.myboutique.dev"}
   :boutiques boutiques
   :rooms rooms
   :guests guests
   :bookings bookings
   :runners runners})
